import React, {useEffect} from 'react'
import {Link} from "react-router-dom"

const Privacy = (props) => {

  useEffect(() => {
    window.scrollTo(0,0)
  },[])

  return ( <>
  <div style={{ position: 'relative' }}>
  {/* Watermark */}
  {/* <img
    src={`${process.env.PUBLIC_URL}/Acacia_RPI.png`}
    alt="Watermark"
    style={{
        position: 'fixed',
        top: '50%',
        left: '75%',
        transform: 'translate(-50%, -50%)',
        opacity: 1,
        zIndex: -99,
        pointerEvents: 'none',
      width: '40%',
    }}
  /> */}




    {/* <audio id="audio" loop autoplay>
        <source src="%
        PUBLIC_URL%/OdeToAcacia.mp3" type="audio/mpeg"></source>
    </audio> */}
    <audio controls src={`${process.env.PUBLIC_URL}/Ode To Acacia - OurStorySong.mp3`}></audio>
    <br/>
    <a href={`${process.env.PUBLIC_URL}/Ode To Acacia - OurStorySong.mp3`} download>Download</a>

    <h2>Ode to Acacia</h2>

    <p>
    [Verse 1]<br/>
    A Troy-city jeweler built a home on a hill,<br/>
    And a hundred years later, it stands there still.<br/>
    With a panoramic view of Hudson Valley below,<br/>
    It watches the seasons through sun and snow.<br/>
    Surrounded by lawn and a low stone wall,<br/>
    At Four Sunset Terrace, looking over it all.<br/>
    <br/>
    [Verse 2]<br/>
    It was once Alpha Tau Omega’s domain,<br/>
    With love and respect guiding their reign.<br/>
    But when they moved out and we moved in,<br/>
    A brand-new chapter was to begin.<br/>
    The letters “ATO” above that old door<br/>
    Meant “Acacia Takes Over” - better than before.<br/>
    <br/>
    [Chorus]<br/>
    Growing our knowledge, expanding our minds,<br/>
    Learning to be truthful, loyal, and kind.<br/>
    Responsibility, leadership, and pride,<br/>
    Forty-one brothers living side by side<br/>
    <br/>
    [Verse 3]<br/>
    House cook Grandma was part of our mix,<br/>
    Using all her best culinary tricks.<br/>
    She made a roast beef stew that was truly grand,<br/>
    Chopping all the veggies and meat by hand.<br/>
    She gave it her best, right from the start.<br/>
    Everyone loved it, except for Pete Hart.<br/>
    <br/>
    [Verse 4]<br/>
    If you weren’t back for dinner at six somehow,<br/>
    There’d be a plate in the oven marked “Late Chow.”<br/>
    Every brother took turns with dishes and plates,<br/>
    And made sure the kitchen was clean by eight.<br/>
    I’d take one last sweep through the place at ten,<br/>
    So Grandma could do it all over again.<br/>
    <br/>
    [Chorus]<br/>
    Growing our knowledge, expanding our minds,<br/>
    Learning to be truthful, loyal, and kind.<br/>
    Responsibility, leadership, and pride,<br/>
    Forty-one brothers living side by side<br/>
    <br/>
    [Verse 5]<br/>
    We all came together, and worked really hard<br/>
    To build an ice-skating rink in our yard.<br/>
    We sprayed down the garden hose, building up ice<br/>
    ’Til we got a smooth surface, so perfectly nice.<br/>
    We practiced our skills and improved our aim<br/>
    For the annual Brother–Alumni game.<br/>
    <br/>
    [Verse 6]<br/>
    After four long years from the ’Tute we’d go,<br/>
    Leaving behind Troy’s slush and snow.<br/>
    Along life’s pathway we made our start,<br/>
    Unsure of direction but full of heart.<br/>
    “Knowledge and Thoroughness” would be our guide,<br/>
    With nostalgic memories deep inside.<br/>
    <br/>
    [Alma Mater]<br/>
    Here's to old RPI, her fame may never die.<br/>
    Here's to old Rensselaer, she stands today without a peer.<br/>
    Here's to those olden days,<br/>
    Here's to those golden days,<br/>
    Here's to the friends we made at dear old RPI.

    </p>
    <img
    src={`${process.env.PUBLIC_URL}/Acacia_RPI_trimmed.png`}
    alt="RPI Acacia Logo"
    style={{
        // position: 'fixed',
        // top: '50%',
        // left: '75%',
        // transform: 'translate(-50%, -50%)',
        // opacity: 1,
        // zIndex: -99,
        // pointerEvents: 'none',
      width: '100%',
    }}
  />
    </div>
  </> )
}

export default Privacy
